<div class="container flex flex-col max-w-6xl px-4 py-8 mx-auto">
    <section class="flex flex-col items-center w-full mb-8 text-center">
        <h1 class="mb-2 text-4xl font-semibold tracking-wide md:text-5xl text-slate-800">Terms and Conditions</h1>
    </section>

    <section class="w-full">
        <aside class="flex flex-col p-8 space-y-6 bg-white shadow rounded-2xl">
            <div class="prose max-w-none">
                <!-- <h3 class="flex items-center gap-2 text-xl font-semibold text-slate-700">
                    <lucide-icon [img]="ScrollText" class="w-5 h-5 text-secondary" />
                    EPIC Terms and Conditions
                </h3> -->

                @if (isLoading) {
                    <div class="flex items-center justify-center py-12">
                        <div
                            class="w-8 h-8 border-4 rounded-full border-primary border-t-transparent animate-spin"
                        ></div>
                        <span class="ml-3 text-gray-600">Loading terms and conditions...</span>
                    </div>
                } @else {
                    <app-safe-rich-text [html]="content"></app-safe-rich-text>
                }
            </div>
        </aside>
    </section>
</div>
